var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"24rem"}},[_c('el-button',{staticStyle:{"height":"32rem","margin-right":"24rem"},attrs:{"size":"small"},on:{"click":_vm.onDownload}},[_vm._v("新高考预选科调查结果导出")]),_c('div',{staticStyle:{"font-size":"12rem","color":"red","margin-top":"12rem"}},[_vm._v("注：此工具用于导出已参与新高考预选科调查问卷学生的预选意向结果导出")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }